import React, { useState, useMemo } from "react";
import { TextInput } from "../Form/TextInput";
import { FormCheckbox } from "../Form/FormCheckbox";
import { Pencil } from "../Icons/Pencil";
import { FloppyDisk } from "../Icons/FloppyDisk";

// Helper funkcia na získanie limitov podľa pohlavia
const getGenderLimit = (genderLimits, gender) => {
  if (!genderLimits || !Array.isArray(genderLimits)) {
    return { lower_limit: null, upper_limit: null };
  }
  const limit = genderLimits.find((gl) => gl.gender === gender);
  return limit || { lower_limit: null, upper_limit: null };
};

export const ComplementParameterRow = ({
  parameter,
  onParameterChange,
  errors = {},
  isOddRow = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  // Získanie limitov pre mužov a ženy
  const maleLimits = useMemo(
    () => getGenderLimit(parameter.gender_limits, "M"),
    [parameter.gender_limits],
  );
  const femaleLimits = useMemo(
    () => getGenderLimit(parameter.gender_limits, "F"),
    [parameter.gender_limits],
  );

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    onParameterChange(parameter.id, parameter, true);
    setIsEditing(false);
  };

  const rowClasses = [
    "complement-parameter-row",
    isOddRow && "complement-parameter-row--odd",
    isEditing && "complement-parameter-row--editing",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rowClasses}>
      {/* Názov parametru */}
      <div className="complement-parameter-cell complement-parameter-cell--name">
        {parameter.name}
      </div>

      {/* Zkr. parametru */}
      <div className="complement-parameter-cell complement-parameter-cell--abbreviation">
        {parameter.abbreviation || ""}
      </div>

      {/* Dolná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--lower-limit">
        {isEditing ? (
          <TextInput
            id={`lower_limit_${parameter.id}`}
            name={`parameters.${parameter.id}.lower_limit`}
            labelDisplay={false}
            className="complement-input"
          />
        ) : (
          <span>{parameter.lower_limit || ""}</span>
        )}
      </div>

      {/* Horná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--upper-limit">
        {isEditing ? (
          <TextInput
            id={`upper_limit_${parameter.id}`}
            name={`parameters.${parameter.id}.upper_limit`}
            labelDisplay={false}
            className="complement-input"
          />
        ) : (
          <span>{parameter.upper_limit || ""}</span>
        )}
      </div>

      {/* Muž - dolná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--gender-limit">
        <span>{maleLimits.lower_limit || ""}</span>
      </div>

      {/* Muž - horná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--gender-limit">
        <span>{maleLimits.upper_limit || ""}</span>
      </div>

      {/* Žena - dolná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--gender-limit">
        <span>{femaleLimits.lower_limit || ""}</span>
      </div>

      {/* Žena - horná mez */}
      <div className="complement-parameter-cell complement-parameter-cell--gender-limit">
        <span>{femaleLimits.upper_limit || ""}</span>
      </div>

      {/* Jednotka */}
      <div className="complement-parameter-cell complement-parameter-cell--units">
        <span>{parameter.units || ""}</span>
      </div>

      {/* Plač. koncentrácie */}
      <div className="complement-parameter-cell complement-parameter-cell--concentration">
        {isEditing ? (
          <FormCheckbox
            id={`is_plasma_concentration_${parameter.id}`}
            name={`parameters.${parameter.id}.is_plasma_concentration`}
            label=""
            labelDisplay={false}
          />
        ) : (
          <div
            className={`complement-concentration-indicator ${
              parameter.is_plasma_concentration
                ? "complement-concentration-indicator--active"
                : "complement-concentration-indicator--inactive"
            }`}
          />
        )}
      </div>

      {/* Akcie */}
      <div className="complement-parameter-cell complement-parameter-cell--actions">
        {isEditing ? (
          <FloppyDisk className="complement-action-icon" onClick={handleSave} />
        ) : (
          <Pencil className="complement-action-icon" onClick={handleEdit} />
        )}
      </div>
    </div>
  );
};
